import './NotificationPopup.scss';
import { Link, useNavigate } from 'react-router-dom';
import GenericButton from '../common/button';
import { Nav } from 'react-bootstrap';
import MessageListComponent from './Messages/component/MessageListComponent';

function NotificationPopup({
  getNotificationCount,
  messageDetails,
  setShowNotification,
  isNotificationPopupList,
}) {
  const navigate = useNavigate();

  return (
    <div className="popup-notification">
      <div className="notification-body d-flex justify-content-between">
        <div className="notification-item">
          <Link
            to={'/member/messages-documents-notifications'}
            state={{
              showmymessage: true,
              notificationCount: getNotificationCount,
            }}
            aria-label={`Click to open My Messages Page, ${getNotificationCount?.Message} unread Messages available.`}
          >
            <span>My Messages</span>
            {getNotificationCount?.Message > 0 && (
              <span className="mymessage-count">
                {getNotificationCount?.Message}
              </span>
            )}
          </Link>
        </div>
        <div className="notification-item">
          <Link
            to={'/member/messages-documents-notifications'}
            state={{
              shownotification: true,
              notificationCount: getNotificationCount,
            }}
            aria-label={`Click to open Updates/Reminders Page, ${getNotificationCount?.Notification} unread Updates/Reminders available.`}
          >
            <span className="documents-count ml-3">
              {getNotificationCount?.Notification > 1
                ? 'Updates/Reminders'
                : 'Update/Reminder'}
            </span>
            {getNotificationCount?.Notification > 0 && (
              <span className="mymessage-count">
                {getNotificationCount?.Notification}{' '}
              </span>
            )}
          </Link>
        </div>
      </div>
      <div className="my-message-border">
        <div className="scroll">
          <Nav
            variant="pills"
            className="messageNotificationItems message-mgt nav nav-pills"
          >
            {messageDetails?.Message?.slice(0, 3).map((item, id) => (
              <MessageListComponent
                isNotificationPopupList={isNotificationPopupList}
                item={item}
                key={id}
                onClick={() =>
                  navigate('/member/messages-documents-notifications', {
                    state: {
                      state: 'mymessage',
                      popUpMessage: item,
                      showmymessage: true,
                      notificationCount: getNotificationCount,
                    },
                  })
                }
              />
            ))}
          </Nav>
        </div>
      </div>
      <div className="p-3 notification_bottom_class d-none">
        <Link
          to={'/member/messages-documents-notifications'}
          state={{
            showmymessage: true,
            notificationCount: getNotificationCount,
          }}
        >
          <GenericButton
            onClick={() => setShowNotification(false)}
            variant="primary"
            className="View-all-button"
          >
            VIEW ALL
          </GenericButton>
        </Link>
        <Link
          to={'/member/messages-documents-notifications'}
          state={{
            showdocuments: true,
            notificationCount: getNotificationCount,
          }}
        >
          <span className="documents-count ml-3">
            {/*{getNotificationCount?.Document}  */}
            Documents
            {/*{getNotificationCount?.Document > 1 ? 's' : ''} */}
          </span>
        </Link>
        <Link
          to={'/member/messages-documents-notifications'}
          state={{
            shownotification: true,
            notificationCount: getNotificationCount,
          }}
        >
          <span className="documents-count ml-3">
            {getNotificationCount?.Notification}{' '}
            {getNotificationCount?.Notification > 1
              ? 'Updates/Reminders'
              : 'Update/Reminder'}
          </span>
        </Link>
      </div>
    </div>
  );
}

export default NotificationPopup;
